<template :key="KEY">
    <div class="previewLineContainer" :style="getLineStyle" v-show="(parseInt(line.masterBlock) && parseInt(label.use_master_block) && ((!parseInt(label.use_icon) && parseInt(line.master_type)) || (parseInt(label.use_icon) && !parseInt(line.master_type))))||(line.copy.length) ||((!parseInt(line.masterBlock) && !parseInt(label.use_master_block)))"  :class="[{ masterBlock: line.masterBlock,isDisplayed:(parseInt(line.masterBlock) && parseInt(label.use_master_block) && ((!parseInt(label.use_icon) && parseInt(line.master_type)) || (parseInt(label.use_icon) && !parseInt(line.master_type))))||(line.copy.length) ||((!parseInt(line.masterBlock) && !parseInt(label.use_master_block))) }]">
         <div class="north" :style="getEditAreaStyle">
             <div class="editArea" :style="getChildStyle" v-bind:id="line.uniqueId"  v-html="getHtml"></div>
         </div>
    </div>
</template>
<script>
    export default {
        props    : ['line','label'],
        computed : {
            getLineStyle () {
                return {
                    'font-family'    : "'" + this.line.font + "'",
                    'font-size'      : this.line.fontsize + "pt",
                /*    'line-height'    : this.line['line-height'] + "px",*/
                    'color'          : "rgb(" + this.line.rgb + ")",
                    'top'            : this.line.top + "px",
                    'left'           : this.line.left + "px",
                    'width'          : this.line.width + "px",
                    'height'         : this.line.height + "px",
                    'z-index'        : this.line.zindex,
                    'text-align'     : this.line.alignment,
                    'vertical-align' : this.line.valignment,
                }
            },
            getHtml(){
                if(this.line.copy.length){
                    const record = this.label.lines.find( element => element.block_name == this.line.copy );
                    if(record){
                      this.line.text = record.text;
                    this.line.fontsize = record.fontsize;
                        return record.text;
                    }
                }
                if ( this.line.text.length ) {
                    return this.line.text;
                }
                if ( ! parseInt( this.line.masterBlock ) )
                    return this.line.placeholder;
                return "";
            },

            getEditAreaStyle () {

                return {
                    'width'            : this.line.real_width + "px",
                    'height'           : this.line.real_height + "px",
                    transform          : "matrix(" + (this.line.page_resize_percentageW / 100) + ", 0, 0," + (this.line.page_resize_percentageH / 100) + ", 0, 0)",
                    'transform-origin' : 'left top'
                }
            },
            getChildStyle () {
                if(!parseInt(this.line.masterBlock)){
                return {
                    'vertical-align' : this.line.valignment,
                }
                }else{
                    return {};
                }
            }
        },

    }
</script>
<style>
    .previewLineContainer {
        position : absolute;
        display:table;
        z-index:999999 !important;
    }
    .editArea {
        transform-origin : left top;
        white-space      : nowrap;
        overflow         : hidden;
        display: table-cell;
        vertical-align: middle;
    }

    .north {
        width  : 100%;
        height : 100%;
        display: table;
    }




    .masterBlock span {
       line-height : 100%;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
      /*  position    : absolute;*/
        left: 0;
        width: 100%;
        white-space: pre;
      /* transform: translateY(-50%);*/
        justify-content: center;
        flex-direction: column;
    text-align: center;
        height: 100%;
    }
    span.removeDisplay,
    div.removeDisplay
    {
        display:inline;
        width:auto;
        max-height:none !important;
        height:auto;

    }

    div.removeDisplay2
    {
        height: auto !important;
        display: inline-block !important;
        width: auto !important;
    }

    span.removeDisplay2{
        height: auto !important;
        width: auto !important;
        display:inline-block;
    }
    .svgSpan{
        height: auto;
        width: auto;
        display: inline-block;
        line-height: 100%;
    }

    .divSvgSpan{
        display: inline-block;
        white-space:no-wrap;
        width: 1px;
        height: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Preview/Previewline.vue